import { render, staticRenderFns } from "./globalMixin.vue?vue&type=template&id=6f26f730&scoped=true&"
import script from "./globalMixin.vue?vue&type=script&lang=js&"
export * from "./globalMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f26f730",
  null
  
)

export default component.exports